import { createFileRoute, Outlet } from '@tanstack/react-router';

// quiz 区域的布局。列表（index）、quiz 详情
// （quizzes/$quizId/*）及其尝试/评分页均通过此 Outlet 渲染。
// 保持纯透传使子组件不获得额外容器——没有此 Outlet
// 嵌套的 quiz 详情 + 尝试页永远不会挂载。
export const Route = createFileRoute('/_learner/courses_/$id/quizzes')({
  component: () => <Outlet />,
});
